/* eslint-disable camelcase */
export default class VendorReturn {
  id = 0;
  delivery_slip_id = 0;
  return_for_reason_id =0;
  partner_id = 0;
  partner_store_id = 0;
  sequence = 0;
  is_shipped = false;
  date_shipped = '';
  rma_no = '';
  memo = '';
  order_sequence = '';
  created_at = '';
  updated_at = '';
  purchase_order = {};
  quarantine_location = {};
  delivery_slip_items = [];

  constructor (data) {
    Object.assign(this, data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/VendorReturn.js